import { ClientTypeAttributes } from '@/types'
import { UpdateClientTypeMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditClientTypeQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type ClientType = EditClientTypeQuery['clientTypes']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<UpdateClientTypeMutation, ClientTypeAttributes, EditClientTypeQuery, ClientType>({
    id,
    initializer: clientType => ({
      name: clientType.name,
      color: clientType.color,
    }),
    query: EditQuery,
    queryKey: 'clientTypes',
    mutation: UpdateMutation,
    resultKey: 'updateClientType'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        { formBuilder.buildField({ name: 'Color', field: 'color', type: 'color' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
